import { Flex, Skeleton } from 'antd'

export const BaseDashboardSkeleton = () => {
  return (
    <>
      <Flex className='w-full h-full my-8 box-border p-4 border-0 shadow-cardChart rounded-2xl border-solid rounded-b-lg bo border-neutral-border-light flex-col'>
        <Skeleton paragraph={{ rows: 0 }} className='mb-4' />
        <Skeleton paragraph={{ rows: 4 }} />
      </Flex>
      <Flex className='w-full h-full my-8 box-border p-4 border-0 shadow-cardChart rounded-2xl border-solid rounded-b-lg bo border-neutral-border-light flex-col'>
        <Skeleton paragraph={{ rows: 0 }} className='mb-4' />
        <Skeleton paragraph={{ rows: 4 }} />
      </Flex>
    </>
  )
}
